import { SxProps, Theme } from '@mui/material';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';

interface TruckAndVendorColumnProps {
  ticket: Ticket;
  sx?: SxProps<Theme>;
}

export default function TruckAndVendorColumn({ ticket, sx }: TruckAndVendorColumnProps) {
  const truckName = ticket.externalTruckId ?? ticket.equipmentName;
  const vendorName = ticket.externalVendorName ?? ticket.vendorName;

  return (
    <FlexColumn sx={sx}>
      {truckName && (
        <OverflowAwareText sx={{ fontWeight: 500 }}>{truckName}</OverflowAwareText>
      )}

      {vendorName && (
        <OverflowAwareText sx={{ color: 'text.secondary' }}>
          {vendorName}
        </OverflowAwareText>
      )}
    </FlexColumn>
  );
}
